import { Inject, Injectable } from "@angular/core";
import { FormArray, FormControlStatus, FormGroup } from "@angular/forms";
import {
  BaseFpxComponentState,
  BaseFpxFormHelper,
  HttpProviderService,
  IHttpSuccessPayload,
  RoutingInfo,
  BaseFpxChangeHandler,
  BaseFpxControlEventHandler,
  HttpRequest,
  SpinnerService,
  ILookupResponse,
  CriteriaQuery
} from "@fpx/core";
import { BehaviorSubject, Observable, map, of } from "rxjs";
import { Router } from "@angular/router";
import { PfmfundsService } from '../pfmfunds-service/pfmfunds.service';
import { Pfmfunds } from '../pfmfunds-service/pfmfunds.model';
import { IPopupScreenData } from "src/app/common/models/popup-screen-data.model";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PfmMainService } from "../services/pfm-main.service";

export class PfmFundsDetailFormState extends BaseFpxComponentState {
 	showSuggestion : boolean = false;
   swipeCoord;
   swipeTime;
   selectedTab=0;
   currentPfmFundsDate:any;
   refreshCriteria$: BehaviorSubject<CriteriaQuery> = new BehaviorSubject<CriteriaQuery>(null);
}


@Injectable()
export class PfmFundsDetailFormHelper extends BaseFpxFormHelper<PfmFundsDetailFormState>{

   constructor( private pfmFundsDetailFormService: PfmfundsService,
    private _httpProvider : HttpProviderService,
    private _router: Router,
    @Inject(MAT_DIALOG_DATA) private data: IPopupScreenData,
    public pfmMainService:PfmMainService)
    {
        super(new PfmFundsDetailFormState());
    }

  override doPreInit(): void {
    this.pfmMainService.selectedPfmFundData = this.data?.screenData?.data;
    let creditFrequency=this.pfmMainService.selectedPfmFundData.frequencyCode;
    let date = this.pfmMainService.currentPfmFundsDate?.split("/");

    this.state.currentPfmFundsDate = this.getFullMonth(date[1])+" "+date[2];
    const criteriaQuery = new CriteriaQuery();
    criteriaQuery.addQueryparam('creditFrequency',creditFrequency);
    this.state.refreshCriteria$.next(criteriaQuery);
  }

  getFullMonth(index){

    let month = [
      "January",
      "February",
      "March ",
      "April ",
      "May ",
      "June ",
      "July ",
      "August ",
      "September ",
      "October ",
      "November ",
      "December",
    ]
    return month[parseInt(index)-1];
  }

  public override doPostInit(): void {

  }


  public override preSubmitInterceptor(payload: Pfmfunds):any {
     // WRITE CODE HERE TO HANDLE
    return payload;
  }

  public override postSubmitInterceptor(response:any): RoutingInfo {
    console.log(response);
    let routingInfo: RoutingInfo = new RoutingInfo();
    routingInfo.setNavigationURL("confirmation");
    if (response.success) {
      routingInfo.setQueryParams({
        transRef: response.success?.body?.fpxdeposit?.depositRef,
        status: "success",
      });
    } else if (response.error) {
      routingInfo.setQueryParams({ status: "failed" });
    }
    return routingInfo;
  }
 //$START_CUSTOMSCRIPT\n
 //$END_CUSTOMSCRIPT\n
 swipe(e: TouchEvent, when: string): void {
  try {
    const coord: [number, number] = [e.changedTouches[0].clientX, e.changedTouches[0].clientY];
    const time = new Date().getTime();
    if (when === 'start') {
      this.state.swipeCoord = coord;
      this.state.swipeTime = time;
    } else if (when === 'end') {
      const direction = [coord[0] - this.state.swipeCoord[0], coord[1] - this.state.swipeCoord[1]];
      const duration = time - this.state.swipeTime;
      if (duration < 1000 //
        && Math.abs(direction[0]) > 30 // Long enough
        && Math.abs(direction[0]) > Math.abs(direction[1] * 3)) { // Horizontal enough
        const swipe = direction[0] < 0 ? 'next' : 'previous';
        console.info(swipe);
        if (swipe === 'next') {
          const isFirst = this.state.selectedTab === 0;
          if (this.state.selectedTab <= 3) {
            this.state.selectedTab = isFirst ? 1 : this.state.selectedTab + 1;
          }
          console.log("Swipe left ? INDEX: " + this.state.selectedTab);
        } else if (swipe === 'previous') {
          const isLast = this.state.selectedTab === 4;
          if (this.state.selectedTab >= 1) {
            this.state.selectedTab = this.state.selectedTab - 1;
          }
          console.log("Swipe right ? INDEX: " + this.state.selectedTab);
        }
        // Do whatever you want with swipe
      }
    }
  } catch (err) {

  }
}
tabChanged(event){

}
}
